<template>
  <div class="row d-flex no-block justify-content-center align-items-center vh-100 bg-brand">
    <div class="col-lg-7 col-md-5 d-flex align-items-center justify-content-center py-2">
      <img :src="require('@/assets/images/tf1live-creation-digitale.png')" style="width: 60%;" />
    </div>
    <div class="h-100 d-flex flex-column justify-content-center col-lg-5 col-md-7 bg-white">
      <img :src="require('@/assets/tf1pub_blue.svg')" alt="" height="100" />
      <h3 class="mt-2 text-center text-dark">Sign in</h3>
      <slot></slot>
    </div>
  </div>
</template>